import clsx from 'clsx';
import { type MutableRefObject, type ReactNode, useState } from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import { PiDotsThree } from 'react-icons/pi';

import ContextMenu from '@/components/ContextMenu/ContextMenu';
import styles from '@components/Modal/Modal.module.scss';

type DesktopModalProps = {
  children: ReactNode;
  onClose: () => void;
  title?: ReactNode;
  containerRef?: MutableRefObject<HTMLElement | null>;
  closable?: boolean;
  haveActions?: boolean;
  onEdit?: () => void;
  onDelete?: () => void;
};

const DesktopModal = ({
  children,
  onClose,
  containerRef,
  title,
  haveActions = false,
  closable = true,
  onEdit,
  onDelete,
}: DesktopModalProps) => {
  const [isContextMenuOpen, setIsContextMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const contextMenuItems = [
    { label: 'Edit', onClick: () => onEdit?.() },
    { label: 'Delete', onClick: () => onDelete?.(), variant: 'danger' as const },
  ];

  return (
    <div className={styles.backdrop} onClick={closable ? onClose : undefined}>
      <div
        ref={(node) => {
          if (containerRef) containerRef.current = node;
        }}
        className={styles.modal}
        onClick={(event) => event.stopPropagation()}
        tabIndex={-1}
      >
        {title && (
          <div className={styles.desktopTitle}>
            {haveActions ? (
              <button
                className={clsx(styles.actionBts)}
                onClick={(e) => {
                  setAnchorEl(e.currentTarget);
                  setIsContextMenuOpen(!isContextMenuOpen);
                }}
              >
                <PiDotsThree />
              </button>
            ) : (
              <div style={{ width: 32, height: 32 }}></div>
            )}

            {title}

            <div style={{ width: 32, height: 32 }}></div>
          </div>
        )}

        <button className={styles.closeBtn} onClick={onClose} aria-label="Close">
          <IoCloseOutline />
        </button>
        <div className={styles.modalContent}>{children}</div>
      </div>
      <ContextMenu
        items={contextMenuItems}
        isOpen={isContextMenuOpen}
        onClose={() => setIsContextMenuOpen(false)}
        anchorEl={anchorEl}
      />
    </div>
  );
};

export default DesktopModal;
